module.exports = __webpack_public_path__ + "media/images/shared/suppliers/JOHNSONCONTROLS-424c83bc04077d3b6a8aa31099f03cb0.jpg";